import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { Box, Grid } from '@mui/material';
import { observer } from 'mobx-react-lite';
import SearchResults from './SearchResults';
import LeftNavBar from './LeftNavBar';
const SearchComponent = ({ searchTerm }) => {
    const [selectedNavBarItem, setSelectedNavBarItem] = useState({
        label: 'Course',
        type: 'course',
    });
    const [title, setTitle] = useState('Course');
    const navbarItems = [
        {
            label: 'Course',
            type: 'course',
        },
        {
            label: 'Program',
            type: 'program',
        },
        {
            label: 'Microcast',
            type: 'microcast',
        },
        {
            label: 'Document',
            type: 'document',
        },
    ];
    useEffect(() => {
        setTitle(selectedNavBarItem.label);
    }, [selectedNavBarItem]);
    return (_jsx(Box, { children: _jsxs(Grid, { container: true, children: [_jsx(Grid, { item: true, xs: 12, md: 2, order: { xs: 1, md: 0 }, sx: {
                        backgroundImage: (theme) => theme.palette.subNav.main,
                        mt: 8.4,
                    }, children: _jsx(LeftNavBar, { sections: navbarItems, selectedItem: selectedNavBarItem, setSelectedItem: setSelectedNavBarItem }) }), _jsx(Grid, { item: true, xs: 12, md: 10, order: { xs: 0, md: 1 }, sx: { p: 2 }, children: _jsx(SearchResults, { title: title, modelName: selectedNavBarItem.type, searchTerm: searchTerm }) })] }) }));
};
SearchComponent.defaultProps = {};
export default observer(SearchComponent);
//# sourceMappingURL=SearchComponent.js.map